/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Code_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Share Code" |
*
* @param {Team_Share_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_code_placeholder = /** @type {((inputs?: Team_Share_Code_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Code_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code de partage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Code teilen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Condividi il codice")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Код доступа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código para compartir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分享代码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コードを共有")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोड साझा करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Compartilhar código")
	return /** @type {LocalizedString} */ ("Share Code")
});